"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../FinancialAidEstimate.module.css"));
function BeonairPage(props) {
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.pageSize + " " + styles.pageBreak },
            props.children,
            react_1.default.createElement("div", { className: "row " + styles.footerPosition + " " + styles.textCenter },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null,
                        "Page ",
                        props.page,
                        " of ",
                        props.totalPages)))),
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
}
exports.BeonairPage = BeonairPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmVvbmFpclBhZ2UuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYmVvbmFpci9Db3JlRXN0L3BhcnRzL0Jlb25haXJQYWdlL0Jlb25haXJQYWdlLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLDhFQUFpRTtBQUVqRSxTQUFnQixXQUFXLENBQUMsS0FBSztJQUM3QixJQUFJLEtBQUssR0FBRyxLQUFLLENBQUE7SUFFakIsSUFBSSxNQUFNLENBQUMsS0FBSyxFQUFFO1FBQ2QsS0FBSyxHQUFHLElBQUksQ0FBQTtLQUNmO0lBRUQsT0FBTyxDQUNILDhCQUFDLGVBQUssQ0FBQyxRQUFRO1FBQ1gsdUNBQUssU0FBUyxFQUFLLE1BQU0sQ0FBQyxRQUFRLFNBQUksTUFBTSxDQUFDLFNBQVc7WUFDbkQsS0FBSyxDQUFDLFFBQVE7WUFDZix1Q0FBSyxTQUFTLEVBQUUsU0FBTyxNQUFNLENBQUMsY0FBYyxTQUFJLE1BQU0sQ0FBQyxVQUFZO2dCQUMvRDtvQkFDSTs7d0JBQ1UsS0FBSyxDQUFDLElBQUk7O3dCQUFNLEtBQUssQ0FBQyxVQUFVLENBQ3RDLENBQ0osQ0FDRixDQUNKO1FBQ0wsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLGVBQWEsTUFBTSxDQUFDLFdBQWEsR0FBUSxDQUN2RCxDQUNwQixDQUFBO0FBQ0wsQ0FBQztBQXRCRCxrQ0FzQkMifQ==